import { createContext, useContext } from "react";
import { readCachedOrgFlag, useCachedOrgFlag } from "../../codesmith/useCachedOrgFlag";

// The workspace pane (diff viewer) is gated per installation by the
// `codesmith_diff_viewer_enabled` flag, which the backend also 404s the
// sandbox diff/file endpoints on. Codesmith resolves it once and provides it
// through WorkspacePaneFlagContext; the session skeletons, which render
// outside that provider, read the cached value directly.

const STORAGE_KEY_PREFIX = "codesmith-diff-viewer-enabled:";
export function readCachedWorkspacePaneEnabled(orgName: string | null): boolean {
  return readCachedOrgFlag(STORAGE_KEY_PREFIX, orgName);
}
export function useCachedWorkspacePaneEnabled(args) {
  return useCachedOrgFlag(STORAGE_KEY_PREFIX, args);
}

/** Provided by Codesmith; Storybook and tests provide it directly. */
export const WorkspacePaneFlagContext = createContext<boolean | null>(null);
export function useWorkspacePaneEnabled() {
  return useContext(WorkspacePaneFlagContext) ?? false;
}